import React from 'react';
import { Box } from '@mui/material';
import Strings from '../../../i18n';
import {
  useGetDeferEventMutation,
  useGetDeferEventOffMutation,
  useGetDeferEventOnMutation
} from '../../../services/device/deviceService';
import {
  StyledContainerFooterSideBar,
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import { GetDeferEventItem } from '../../../components/getDeferEventItem/getDeferEventItem';

interface SendDirectMethodProps {
  deviceIds: string[];
  setOpenRightSideBar: (value: boolean) => void;
  clearSelectedDevices: () => void;
}
export const GetDeferEventTime = ({
  deviceIds,
  setOpenRightSideBar,
  clearSelectedDevices
}: SendDirectMethodProps) => {
  const [
    getDeferEvent,
    { isLoading: isLoadingGetDeferEvent, data: getDeferEventResponse }
  ] = useGetDeferEventMutation();

  const [
    sendDeferEventOnMutation,
    { data: getDeferEventOnResponse, isLoading: isLoadingDeferEventOnMutation }
  ] = useGetDeferEventOnMutation();

  const [
    sendDeferEventOffMutation,
    {
      data: getDeferEventOffResponse,

      isLoading: isLoadingDeferEventOffMutation
    }
  ] = useGetDeferEventOffMutation();

  const handleGetDeferEvent = () => {
    getDeferEvent({ deviceIds });
  };

  const handleGetDeferEventOn = () => {
    sendDeferEventOnMutation({ deviceIds });
  };

  const handleGetDeferEventOff = () => {
    sendDeferEventOffMutation({ deviceIds });
  };

  return (
    <Box>
      <StyledContainerItems>
        <StyledTitleSideBar>
          {Strings.serverAccess.devices.getDeferTime}
        </StyledTitleSideBar>
        <GetDeferEventItem
          nameCommand={Strings.serverAccess.devices.getUTCTime}
          loading={isLoadingGetDeferEvent}
          onSave={handleGetDeferEvent}
          data={getDeferEventResponse}
        />
        <GetDeferEventItem
          nameCommand={Strings.serverAccess.devices.getDeferOnEventTime}
          loading={isLoadingDeferEventOnMutation}
          onSave={handleGetDeferEventOn}
          data={getDeferEventOnResponse}
        />

        <GetDeferEventItem
          data={getDeferEventOffResponse}
          nameCommand={Strings.serverAccess.devices.getDeferOffEventTime}
          loading={isLoadingDeferEventOffMutation}
          onSave={handleGetDeferEventOff}
        />
      </StyledContainerItems>
      <StyledContainerFooterSideBar>
        <button
          type="button"
          className="btn-cancel"
          onClick={() => {
            setOpenRightSideBar(false);
            clearSelectedDevices();
          }}
        >
          {Strings.common.cancel}
        </button>
      </StyledContainerFooterSideBar>
    </Box>
  );
};
